import * as React from 'react';

export default () => (
  <svg width="24" height="25" fill="none">
    <path d="M7 12.647h10M12 7.647v10" stroke="#0067F4" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
